import { axiosClient } from '@/shared/apis/config';
import { DtoFolderItemType } from '@/shared/constants';
import { ApiResponse } from '@/shared/types/api/response';
import { CustomQueryOptions } from '@/shared/types/global/react-query/query';
import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

/**
 * 북마크 응답 스키마
 */
export const bookmarkDtoSchema = z.object({
  targetType: z.nativeEnum(DtoFolderItemType),
  targetId: z.number(),
});

export type BookmarkDto = z.infer<typeof bookmarkDtoSchema>;

/**
 * 북마크 목록 API 응답 타입
 */
type GetMyBookmarksResponse = ApiResponse<BookmarkDto[]>;

/**
 * 내 북마크 목록을 가져오는 API 함수
 *
 * @returns 북마크 목록 응답
 */
export const getMyBookmarksApi = async () => {
  const response =
    await axiosClient.get<GetMyBookmarksResponse>('/v1.0/bookmarks');
  return response.data;
};

/**
 * 북마크 목록 쿼리 키
 */
export const QueryKeyUseGetMyBookmarksApi = 'bookmarks' as const;

/**
 * 내 북마크 목록을 가져오는 React Query 훅
 *
 * @param options - React Query 옵션
 * @returns 북마크 목록 쿼리 결과
 */
export const useGetMyBookmarksApi = (
  options?: CustomQueryOptions<GetMyBookmarksResponse>,
) => {
  const { queryKey, ...rest } = options ?? {};

  return useQuery({
    queryKey: [QueryKeyUseGetMyBookmarksApi, ...(queryKey ?? [])],
    queryFn: getMyBookmarksApi,
    staleTime: Infinity, // 수동 갱신
    ...rest,
  });
};
